<template>
  <section class="mission-achievement"
           :class="{ 'main-mission-achievement' : isMain }"
           @click="onClick"
  >
    <div class="mission-achievement-content">
      <div class="mission-achievement-header">
        <h4 class="mission-achievement-title">미션 수행률</h4>
        <p class="mission-achievement-comment">
          <b class="value">{{ innerValue }}%</b>
          {{ isMain ? statusDetail.mainComment : statusDetail.comment }}
        </p>
      </div>
      <div class="mission-achievement-body">
        <div class="mission-progress-bar" :class="statusDetail.class">
          <div class="progress-bar"><i :style="{ width: barWidth }"></i></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MissionAchievement',
  props: {
    type: {},
    value: {} // 수행 개수
  },
  data: () => ({
    innerValue: null
  }),
  computed: {
    isMain () {
      return this.type === 'main'
    },
    barWidth () {
      return `calc(${this.value}% + 15px)`
    },
    statusDetail () {
      console.log(this.value)
      // null 존재함
      let content = {
        comment: '우리 함께 열심히 해봐요!',
        mainComment: '우리 함께 열심히 해봐요',
        class: 'step1'
      }
      if (this.value > 0 && this.value <= 50) {
        content = {
          comment: '달성했어요',
          mainComment: '달성했어요',
          class: 'step2'
        }
      } else if (this.value > 50 && this.value < 100) {
        content = {
          comment: '달성했어요',
          mainComment: '달성했어요!',
          class: 'step3'
        }
      } else if (this.value === 100) {
        content = {
          comment: '달성했어요',
          mainComment: '달성했어요!',
          class: 'step3'
        }
      }
      return content
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (nV) {
        this.innerValue = nV
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('onClick')
    }
  }
}
</script>
